module.exports = __webpack_public_path__ + "img/ysy.2b32a82e.png";